import { render, staticRenderFns } from "./NachaModal.vue?vue&type=template&id=010a9076&scoped=true&"
import script from "./NachaModal.vue?vue&type=script&lang=js&"
export * from "./NachaModal.vue?vue&type=script&lang=js&"
import style0 from "./NachaModal.vue?vue&type=style&index=0&id=010a9076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010a9076",
  null
  
)

component.options.__file = "NachaModal.vue"
export default component.exports